import type { Fallacy } from "./types";
import { createStory } from "./types";

export const survivorshipBias: Fallacy = {
    id: "survivorship-bias",
    name: "Survivorship Bias",
    emoji: "🏆",
    category: "Manipulasi Statistik",
    description: "**Hanya melihat yang berhasil** dan mengabaikan yang gagal, menghasilkan **kesimpulan bias**.",
    tldr: "Cuma lihat yang sukses, lupa yang gagal jauh lebih banyak.",
    detail: "Survivorship Bias terjadi ketika kita hanya memperhatikan contoh yang **'selamat' atau berhasil**, sambil **mengabaikan yang gagal**. Ini menciptakan ilusi bahwa keberhasilan lebih mudah dicapai daripada kenyataannya.\n\nContoh klasik: menunjuk pengusaha sukses yang putus kuliah seperti Bill Gates sebagai bukti kuliah tidak penting, padahal jutaan yang juga putus kuliah namun gagal tidak pernah diberitakan. Kita hanya melihat yang **selamat dari 'filter' kegagalan**.\n\nUntuk menghindari bias ini, selalu tanyakan: 'Berapa banyak yang mencoba hal yang sama tapi gagal?' dan 'Apakah saya hanya melihat sebagian dari gambaran yang lebih besar?'",
    story: createStory("Survivorship Bias", "🏆", {
      hook: {
        title: "Bill Gates dropout. Zuckerberg dropout.",
        body: "Berarti kuliah gak penting? Eits, kamu cuma liat yang berhasil. Yang gagal mana?",
      },
      convo: {
        claim: "Gates dropout, Zuckerberg dropout. **Kuliah itu gak penting**, yang penting action dan skill!",
        response: "Yang dropout tapi gagal ada jutaan. **Kamu cuma lihat 2-3 yang berhasil.**",
      },
      reveal: {
        body: "Kamu cuma lihat yang **\"selamat\"** — yang berhasil, yang sukses. Yang gagal? **Gak pernah keliatan** karena mereka gak posting, gak diberitain.",
      },
      insight: {
        title: "Kenapa kita ketipu?",
        body: "Yang gagal **gak posting, gak diberitain, gak keliatan**. Kamu cuma lihat yang selamat — dan nyimpulin sukses itu gampang.",
      },
      engagement: {
        title: "Pernah hampir ketipu kisah sukses dropout atau \"bisnis gampang\"?",
        body: "Dropout kuliah atau all-in crypto? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["cherry-picking", "hasty-generalization", "base-rate-fallacy", "sampling-bias"],
  };
